export const AUDIT_CATEGORIES = ["phi", "auth", "authz", "admin", "audit", "device"] as const;

export const AUDIT_OUTCOMES = ["success", "denied", "failure"] as const;

export interface AuditEvent {
  eventId: string;
  eventType: string;
  category: string;
  occurredAt: string;
  actor?: {
    userId?: string;
    role?: string;
    orgId?: string;
    distId?: string;
    authMethod?: string;
    deviceId?: string;
  };
  subject?: {
    type: string;
    ids?: string[];
    orgId?: string;
    patientUuid?: string;
  };
  context?: {
    requestId?: string;
    ip?: string;
    geo?: { country?: string; city?: string };
    route?: string;
    method?: string;
    source?: string;
  };
  outcome?: {
    status: string;
    statusCode?: number;
    reason?: string;
  };
}

export interface AuditEventsResponse {
  data: AuditEvent[];
  total: number;
  page: number;
  limit: number;
}
